import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.grey1,
    margin: '0 auto',
    paddingBottom: '40px',

    '& .roomPreferences': {
      margin: '0 auto',
      maxWidth: '1160px',
      overflow: 'hidden',
      padding: '60px 0',
      [theme.breakpoints.down('lg')]: {
        padding: '50px 0',
      },
      [theme.breakpoints.down('md')]: {
        padding: '40px 0',
        maxWidth: '100%',
        width: 'auto',
      },
      [theme.breakpoints.down('sm')]: {
        padding: '30px 0',
        maxWidth: '100%',
        paddingBottom: '0',
        width: 'auto',
      },
      '&__title': {
        marginBottom: '24px',
        textAlign: 'left',
        '& h4': {
          ...theme.typography.h4,
          color: theme.palette.blue1,
        },
      },
      '& .slick-slide': {
        padding: '0',
      },
    },

    '& .roomInfoDialog': {
      display: 'block',

      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },

    '&.iOS': {
      '& .MuiInput-input, & .MuiInput-input::placeholder': {
        border: '0',
      },
    },
  },
  notificationContainer: {
    maxWidth: 1440,
    margin: '0 auto',
    color: theme.palette.grey1,
    padding: '0px 20px 16px',

    [theme.breakpoints.up('sm')]: {
      paddingTop: 20,
    },
    [theme.breakpoints.up('md')]: {
      padding: '20px 35px 20px',
    },
    [theme.breakpoints.up('xl')]: {
      paddingLeft: 50,
      paddingRight: 50,
      paddingTop: 0,
    },
  },
}));

export default useStyles;
